import { Fragment, useState, useEffect } from "react"
import FirearmCard from "../Common/FirearmCard.jsx"
import { router } from "@inertiajs/react"

export const AuctionEndingSoon = ({ items }) => {
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        router.on("start", () => setLoading(true))
        router.on("finish", () => {
            setLoading(false)
        })
    }, [])

    return (
        <div className="flex-none">
            {!loading && (
                <div className="grid grid-cols-1 gap-8 mb-10 lg:grid-cols-2">
                    {items?.slice(0, 8).map((item, index) => (
                        <Fragment key={item?.id}>
                            <FirearmCard data={item} index={index} />
                        </Fragment>
                    ))}
                </div>
            )}

            <div className="flex flex-col items-center justify-center gap-4">
                <a
                    href="/auctions"
                    className="w-64 px-4 py-2 text-center transition-colors rounded-lg text-neutral-50 bg-maroon hover:bg-maroon-light"
                >
                    View All Auctions
                </a>

                <a
                    href="/sell-my-gun"
                    className="hidden w-64 px-4 py-2 text-center transition-colors rounded-lg lg:block text-neutral-50 bg-maroon hover:bg-maroon-light"
                >
                    Sell or Consign a Gun
                </a>
            </div>
        </div>
    )
}
